import type { PaletteOptions } from "@mui/material";
import { colors } from "./colors";

export const lightPalette: Readonly<Omit<PaletteOptions, "mode">> = {
  common: {
    black: colors.black,
    white: colors.white,
  },
  primary: {
    main: colors.emerald[500],
    dark: colors.emerald[600],
    light: colors.emerald[200],
    contrastText: colors.white,
  },
  secondary: {
    main: colors.gray[900],
    dark: colors.gray[600],
    light: colors.gray[400],
    contrastText: colors.gray[900],
  },
  error: {
    main: colors.red[500],
    dark: colors.red[600],
    light: colors.red[400],
    contrastText: colors.white,
  },
  warning: {
    main: colors.orange[500],
    dark: colors.orange[600],
    light: colors.orange[400],
    contrastText: colors.white,
  },
  info: {
    main: colors.sky[500],
    dark: colors.sky[600],
    light: colors.sky[400],
    contrastText: colors.white,
  },
  success: {
    main: colors.green[500],
    dark: colors.green[600],
    light: colors.green[400],
    contrastText: colors.white,
  },
  text: {
    primary: colors.gray[900],
    secondary: colors.gray[500],
    disabled: colors.gray[700],
  },
  branding: {
    main: colors.branding[500],
    dark: colors.branding[600],
    light: colors.branding[400],
    contrastText: colors.white,
  },
  divider: colors.gray[200],
  background: {
    default: colors.background[500],
    paper: colors.white,
  },
  action: {
    active: colors.black,
  },
  custom: {
    activeButton: colors.gray[100],
    inputBorder: colors.borders[400],
    inputColor: colors.gray[900],
    inputLabelColor: colors.gray[400],
    dividerDrawer: colors.gray[200],
  },
};
